<template>
  <span
    :class="
      twMerge(
        'font-serif text-lg uppercase leading-snug',
        typeof $attrs.class === 'string' ? $attrs.class : undefined,
      )
    "
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
// Sibling: packages/astro-ui/src/components/atoms/SubTitle.astro
import { twMerge } from 'tailwind-merge'
</script>
